//  Time-stamp: "2016-07-25 06:36:46 MDT"
module.exports = [
'A', 'a', 'B', 'b', 'B', 'b', 'B', 'b', 'C', 'c', 'D', 'd', 'D', 'd', 'D', 'd',
'D', 'd', 'D', 'd', 'E', 'e', 'E', 'e', 'E', 'e', 'E', 'e', 'E', 'e', 'F', 'f',
'G', 'g', 'H', 'h', 'H', 'h', 'H', 'h', 'H', 'h', 'H', 'h', 'I', 'i', 'I', 'i',
'K', 'k', 'K', 'k', 'K', 'k', 'L', 'l', 'L', 'l', 'L', 'l', 'L', 'l', 'M', 'm',
'M', 'm', 'M', 'm', 'N', 'n', 'N', 'n', 'N', 'n', 'N', 'n', 'O', 'o', 'O', 'o',
'O', 'o', 'O', 'o', 'P', 'p', 'P', 'p', 'R', 'r', 'R', 'r', 'R', 'r', 'R', 'r',
'S', 's', 'S', 's', 'S', 's', 'S', 's', 'S', 's', 'T', 't', 'T', 't', 'T', 't',
'T', 't', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'V', 'v', 'V', 'v',
'W', 'w', 'W', 'w', 'W', 'w', 'W', 'w', 'W', 'w', 'X', 'x', 'X', 'x', 'Y', 'y',
'Z', 'z', 'Z', 'z', 'Z', 'z', 'h', 't', 'w', 'y', 'a', 's', 's', 's', 'Ss', 'd',
'A', 'a', 'A', 'a', 'A', 'a', 'A', 'a', 'A', 'a', 'A', 'a', 'A', 'a', 'A', 'a',
'A', 'a', 'A', 'a', 'A', 'a', 'A', 'a', 'E', 'e', 'E', 'e', 'E', 'e', 'E', 'e',
'E', 'e', 'E', 'e', 'E', 'e', 'E', 'e', 'I', 'i', 'I', 'i', 'O', 'o', 'O', 'o',
'O', 'o', 'O', 'o', 'O', 'o', 'O', 'o', 'O', 'o', 'O', 'o', 'O', 'o', 'O', 'o',
'O', 'o', 'O', 'o', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u', 'U', 'u',
//  0x1EF_:

'U',// 1EF0	LATIN CAPITAL LETTER U WITH HORN AND DOT BELOW
// 	: 01AF 0323
'u',// 1EF1	LATIN SMALL LETTER U WITH HORN AND DOT BELOW
// 	: 01B0 0323
// @		Latin general extensions
'Y',// 1EF2	LATIN CAPITAL LETTER Y WITH GRAVE
// 	: 0059 0300
'y',// 1EF3	LATIN SMALL LETTER Y WITH GRAVE
// 	* Welsh
// 	: 0079 0300
'Y',// 1EF4	LATIN CAPITAL LETTER Y WITH DOT BELOW
// 	: 0059 0323
'y',// 1EF5	LATIN SMALL LETTER Y WITH DOT BELOW
// 	: 0079 0323
'Y',// 1EF6	LATIN CAPITAL LETTER Y WITH HOOK ABOVE
// 	: 0059 0309
'y',// 1EF7	LATIN SMALL LETTER Y WITH HOOK ABOVE
// 	: 0079 0309
'Y',// 1EF8	LATIN CAPITAL LETTER Y WITH TILDE
// 	: 0059 0303
'y',// 1EF9	LATIN SMALL LETTER Y WITH TILDE
// 	: 0079 0303
// @		Medievalist additions
"LL",// 1EFA	LATIN CAPITAL LETTER MIDDLE-WELSH LL
"ll",// 1EFB	LATIN SMALL LETTER MIDDLE-WELSH LL
"V",// 1EFC	LATIN CAPITAL LETTER MIDDLE-WELSH V
"v",// 1EFD	LATIN SMALL LETTER MIDDLE-WELSH V
"Y",// 1EFE	LATIN CAPITAL LETTER Y WITH LOOP
"y",// 1EFF	LATIN SMALL LETTER Y WITH LOOP

];
